import { bestpark } from './base-api';

const postCustomer = async (data: object): Promise<number> => {
  const result = await bestpark.post('/customers', data);
  return result.data;
};

const updateCustomer = async (data: Customer): Promise<string> => {
  const result = await bestpark.put(`/customers/${data.id}`, data);
  return result.data;
};

const profile = async (headers: object): Promise<Customer> => {
  const result = await bestpark.get('/customers/profile', {}, headers);
  return result.data;
};

const emailExists = async (email: string): Promise<string> => {
  const params = { email };
  const result = await bestpark.get('/customers/emailExists', params);
  return result.data;
};

const updateLoginIntent = async (data: object): Promise<Customer> => {
  const result = await bestpark.post('/customers/updateLoginIntent', data);
  return result.data;
};

const getCustomerReservations = async (
  key: string,
  customerId: Number,
): Promise<Reservation[]> => {
  const result = await bestpark.get(`/customers/${customerId}/reservations`);
  return result.data;
};

export const customersApi = {
  postCustomer,
  profile,
  emailExists,
  updateCustomer,
  getCustomerReservations,
  updateLoginIntent,
};
